import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/modules/shared.module';
import { InboundFlightCardComponent } from './inbound-flight-card/inbound-flight-card.component';
import { CrewModule } from '../crew/crew.module';

@NgModule({
  declarations: [InboundFlightCardComponent],
  imports: [CommonModule, SharedModule, CrewModule],
  exports: [InboundFlightCardComponent],
})
export class InboundFlightModule {}
